"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchMenu = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var Input_1 = tslib_1.__importDefault(require("@material-ui/core/Input"));
var Icon_1 = tslib_1.__importDefault(require("@material-ui/core/Icon"));
var styles_1 = require("@material-ui/styles");
var index_1 = require("../../index");
var useStyle = styles_1.makeStyles({
    FilterInputView: {
        width: "100%",
        height: 30,
    },
    FilterInputView_wrap: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginLeft: 14,
        marginRight: 14,
        height: 30,
    },
    FilterInputView_content: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: 30,
        borderRadius: 2,
        border: "1px solid rgba(42,46,46,1)",
    },
    FilterInputView_foot: {
        width: "100%",
        fontSize: 14,
        fontWeight: 400,
        marginLeft: 9,
        marginRight: 9,
    },
    cancelIcon: {
        marginRight: 5,
        cursor: "pointer",
    },
    MainMenuWrap: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
    },
});
function SearchMenu(props) {
    var data = props.data, onClick = props.onClick;
    var _a = tslib_1.__read(react_1.useState(""), 2), searchVal = _a[0], setValue = _a[1];
    var originalMenuData = data.nodes.nodes;
    function trim(str) {
        return str.replace(/(^\s*)|(\s*$)/g, "");
    }
    var menuData = react_1.useMemo(function () {
        var newfilterData = [];
        originalMenuData.map(function (item) {
            return item.nodes.map(function (item) { return newfilterData.push(item); });
        });
        var newSearchVal = trim(searchVal);
        var filterList = newfilterData.filter(function (item) {
            if (item.searchKeywords) {
                var isMatch = item.searchKeywords.some(function (keyword) {
                    var searchIndex = keyword.toLowerCase().indexOf(newSearchVal);
                    item.searchIndex = searchIndex;
                    return searchIndex !== -1;
                });
                return isMatch;
            }
            return false;
        });
        var sortList = filterList.sort(function (item1, item2) {
            return item1.searchIndex - item2.searchIndex;
        });
        return sortList;
    }, [searchVal, originalMenuData]);
    var handleonChange = function (e) {
        setValue(e.target.value);
    };
    var handleClearValue = function () {
        setValue("");
    };
    var classes = useStyle();
    function ShowSearchMenu() {
        return (react_1.default.createElement("div", { className: classes.FilterInputView },
            react_1.default.createElement("div", { className: classes.FilterInputView_wrap },
                react_1.default.createElement("div", { className: classes.FilterInputView_content },
                    react_1.default.createElement(Input_1.default, { className: classes.FilterInputView_foot, placeholder: data.nodes.nodes[0].nodes[0].placeholder, disableUnderline: true, value: searchVal, onChange: handleonChange }),
                    searchVal !== "" && (react_1.default.createElement(Icon_1.default, { className: classes.cancelIcon, onClick: handleClearValue, style: { fontSize: 16 } }, "cancel"))))));
    }
    return (react_1.default.createElement("div", null,
        data.nodes.nodes[0].type === "layout_container" && (react_1.default.createElement(index_1.LayoutContainerTB, null,
            " ",
            ShowSearchMenu())),
        data.nodes.nodes[0].type === "layout_container_t6px" && (react_1.default.createElement(index_1.LayoutContainerT6px, null,
            " ",
            ShowSearchMenu())),
        data.nodes.nodes[0].type === "layout_container_b6px" && (react_1.default.createElement(index_1.LayoutContainerB6px, null,
            " ",
            ShowSearchMenu())),
        data.nodes.nodes[0].type === "layout_container_tb3px" && (react_1.default.createElement(index_1.LayoutContainerTB3px, null,
            " ",
            ShowSearchMenu())),
        data.nodes.nodes[0].type === "layout_container_tb6px" && (react_1.default.createElement(index_1.LayoutContainerTB6px, null,
            " ",
            ShowSearchMenu())),
        data.nodes.nodes[0].type === "layout_container_tb8px" && (react_1.default.createElement(index_1.LayoutContainerTB8px, null,
            " ",
            ShowSearchMenu())),
        react_1.default.createElement("div", null,
            searchVal === "" && (react_1.default.createElement("div", null, data.nodes.nodes.map(function (item, index) { return (react_1.default.createElement("div", { key: index, className: classes.MainMenuWrap }, item.nodes[0].type !== "filter_input_view" && (react_1.default.createElement("div", null,
                item.type === "layout_container" && (react_1.default.createElement(index_1.LayoutContainerTB, null,
                    react_1.default.createElement("div", { className: classes.MainMenuWrap },
                        react_1.default.createElement(index_1.ViewType, { data: item.nodes, onClick: onClick })))),
                item.type === "layout_container_t6px" && (react_1.default.createElement(index_1.LayoutContainerT6px, null,
                    react_1.default.createElement("div", { className: classes.MainMenuWrap },
                        react_1.default.createElement(index_1.ViewType, { data: item.nodes, onClick: onClick })))),
                item.type === "layout_container_b6px" && (react_1.default.createElement(index_1.LayoutContainerB6px, null,
                    react_1.default.createElement("div", { className: classes.MainMenuWrap },
                        react_1.default.createElement(index_1.ViewType, { data: item.nodes, onClick: onClick })))),
                item.type === "layout_container_tb3px" && (react_1.default.createElement(index_1.LayoutContainerTB3px, null,
                    react_1.default.createElement("div", { className: classes.MainMenuWrap },
                        react_1.default.createElement(index_1.ViewType, { data: item.nodes, onClick: onClick })))),
                item.type === "layout_container_tb6px" && (react_1.default.createElement(index_1.LayoutContainerTB6px, null,
                    react_1.default.createElement("div", { className: classes.MainMenuWrap },
                        react_1.default.createElement(index_1.ViewType, { data: item.nodes, onClick: onClick })))),
                item.type === "layout_container_tb8px" && (react_1.default.createElement(index_1.LayoutContainerTB8px, null,
                    react_1.default.createElement("div", { className: classes.MainMenuWrap },
                        react_1.default.createElement(index_1.ViewType, { data: item.nodes, onClick: onClick })))),
                item.type === "divider" && react_1.default.createElement(index_1.Divider, null))))); }))),
            searchVal !== "" && (react_1.default.createElement("div", null,
                react_1.default.createElement(index_1.ViewType, { data: menuData, onClick: onClick }))))));
}
exports.SearchMenu = SearchMenu;
//# sourceMappingURL=index.js.map